export const ENV_URL = import.meta.env.VITE_API_URL;
export const STATIC_FILES_URL = import.meta.env.VITE_STATIC_FILES_URL;
export const APP_ENV = import.meta.env.VITE_APP_ENV;
